














import { SimpleInputConstructor } from './simpleInputSrc';
import SimpleInput from './SimpleInput.vue';

type Mask = { mask: string | any[]; tokens: object; masked: boolean } | undefined;

export default SimpleInputConstructor.extend({
	name: 'DmsInput',
	components: { SimpleInput },
	props: {
		span: {
			type: Number,
			default: 24,
		},
	},
	data() {
		return {
			lastValue: undefined, // avoid unecessary emit when has no change
			displayValue: this.value,
		};
	},
	mounted() {
		this.$refs.input && (this.formItem = (this.$refs.input as any).$refs?.wrapper?.formItem);
		if (this.autofocus) {
			this.focus();
		}
	},
	methods: {
		focus() {
			(this.$refs.input as HTMLInputElement).focus();
		},
		update(val: any) {
			this.$emit('update:value', val);
		},
	},
});
